module.exports = __webpack_public_path__ + "assets/img/activity-time-530aebd9.png";